/* 
自动曝光埋点  使用方式：使用自定义指令 v-buried ，元素属性设置未 data-buried="事件key"
*/
import Controls from '@/common/buried-point/control'
const Control = new Controls()
export default {
  inserted: function (el, binding) {
    Control.add(el, binding)
  },
  mounted: function (el, binding) {
    console.log('自定义组件更新了')
  }
}
